export const defaultTypePolicies = {
  AcceptTermsMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Account: { keyFields: ["id"] },
  ActivitiesInterface: { keyFields: ["id"] },
  ActivityReactionType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Age: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AirdropPromotionalEvent: { keyFields: ["slug"] },
  AlternativeRewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Announcement: { keyFields: ["id"] },
  AnnouncementNotification: { keyFields: ["id"] },
  AnonymousUser: { keyFields: ["id"] },
  AnyCardInterface: { keyFields: ["slug"] },
  AnyCardReward: { keyFields: ["id"] },
  AnyCardSubscription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AnyCardWithPlayerGameScore: { keyFields: ["id"] },
  AnyContestantInterface: { keyFields: ["id"] },
  AnyConversionCreditReward: { keyFields: ["id"] },
  AnyGameInterface: { keyFields: ["id"] },
  AnyPlayerGameStatsInterface: { keyFields: ["id"] },
  AnyPlayerInterface: { keyFields: ["slug"] },
  AnyPlayerNewsUpdate: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AnyRewardConfigInterface: { keyFields: ["id"] },
  AnyRewardInterface: { keyFields: ["id"] },
  AppearanceBoostShopItem: { keyFields: ["id"] },
  AppearanceRule: { keyFields: ["id"] },
  ApplePurchaseToken: { keyFields: ["id"] },
  AuctionNotification: { keyFields: ["id"] },
  AuctionReminder: { keyFields: ["id"] },
  AuthorizationRequest: { keyFields: ["id"] },
  AutoClaimNotification: { keyFields: ["id"] },
  AvailableBalances: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AverageLastScore: { keyFields: ["id"] },
  AverageLastScoreInterface: { keyFields: ["id"] },
  AverageScoreOpenBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  AverageScoresRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BankAccountInterface: { keyFields: ["id"] },
  BankWithdrawal: { keyFields: ["id"] },
  BaseAverageLastScore: { keyFields: ["id"] },
  BaseWithdrawalAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BaseballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BaseballCard: { keyFields: ["slug"] },
  BaseballContestantType: { keyFields: ["id"] },
  BaseballPlayer: { keyFields: ["slug"] },
  BaseballPlayerGameScore: { keyFields: ["id"] },
  BaseballTeamGameStats: { keyFields: ["id"] },
  BaseballUserSportProfile: { keyFields: ["id"] },
  BasketballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BasketballContestantType: { keyFields: ["id"] },
  BasketballDivision: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BasketballPlayerGameScore: { keyFields: ["id"] },
  BasketballTeamGameStats: { keyFields: ["id"] },
  BenchSort: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  BidSource: { keyFields: ["id"] },
  BidToEarnReward: { keyFields: ["id"] },
  BidToEarnRewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Blueprint: { keyFields: ["id"] },
  BoostLevel: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CaBankAccount: { keyFields: ["id"] },
  Card: { keyFields: ["slug"] },
  CardBoost: { keyFields: ["id"] },
  CardBoostConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollection: { keyFields: ["slug"] },
  CardCollectionBonusThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionCard: { keyFields: ["id"] },
  CardCollectionCardScoreBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionNotification: { keyFields: ["id"] },
  CardCollectionRequirement: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionScoreIncrease: { keyFields: ["id"] },
  CardCollectionScoringMatrix: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardCollectionSlot: { keyFields: ["id"] },
  CardCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardEditionCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardEditionsCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardLayout: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardNotification: { keyFields: ["id"] },
  CardPack: { keyFields: ["slug"] },
  CardPackGroup: { keyFields: ["id"] },
  CardPackReward: { keyFields: ["id"] },
  CardPackSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlotPlayingStatusOdd: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPackSlotRankOdd: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPacksRewardConfig: { keyFields: ["id"] },
  CardPull: { keyFields: ["id"] },
  CardPullCard: { keyFields: ["id"] },
  CardPullConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardPullSource: { keyFields: ["id"] },
  CardRewardConfig: { keyFields: ["id"] },
  CardSample: { keyFields: ["id"] },
  CardSeasonSupply: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardRewardConfig: { keyFields: ["id"] },
  CardShardThresholdsPromotionalEvent: { keyFields: ["slug"] },
  CardShardsChest: { keyFields: ["id"] },
  CardShardsChestThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsChestThresholdDraw: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsChestThresholdProbability: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardShardsReward: { keyFields: ["id"] },
  CardSource: { keyFields: ["id"] },
  CardStats: { keyFields: ["id"] },
  CardUsageInterface: { keyFields: ["slug"] },
  CardXPGradeThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardsCountAsFirstOwnerRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CardsCountTask: { keyFields: ["id"] },
  Cart: { keyFields: ["id"] },
  CartItem: { keyFields: ["id"] },
  CartPurchaseRewardPromotionalEvent: { keyFields: ["slug"] },
  CheckoutCreditCardAuthorizationRequest: { keyFields: ["id"] },
  Club: { keyFields: ["slug"] },
  CoinReward: { keyFields: ["id"] },
  CoinRewardConfig: { keyFields: ["id"] },
  CollectionTaskThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CommonAccount: { keyFields: ["id"] },
  CommonCardSwapShopItem: { keyFields: ["id"] },
  CommonGameEndOfSeasonCountdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CommonPlayer: { keyFields: ["id"] },
  Competition: { keyFields: ["slug"] },
  CompetitionCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompetitionGames: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CompletablePromotionalEvent: { keyFields: ["slug"] },
  CompletablePromotionalEventInterface: { keyFields: ["slug"] },
  CompleteCollectionsCountTask: { keyFields: ["id"] },
  ComposeTeamBenchCard: { keyFields: ["id"] },
  ComposeTeamBenchCommonPlayer: { keyFields: ["id"] },
  ComposeTeamBenchObjectInterface: { keyFields: ["id"] },
  Config: { keyFields: ["id"] },
  ConfirmDeviceMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ConfirmEmailMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ConnectedOAuth: { keyFields: ["id"] },
  ConsumeEphemeralTokenMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Contestant: { keyFields: ["id"] },
  Contract: { keyFields: ["id"] },
  ConversionCredit: { keyFields: ["id"] },
  ConversionCreditCampaign: { keyFields: ["id"] },
  ConversionCreditNotification: { keyFields: ["id"] },
  ConversionCreditRewardConfig: { keyFields: ["id"] },
  CountByRarity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Country: { keyFields: ["slug"] },
  Counts: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CreateOrUpdateSo5LineupMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CreditCard: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  CurrentUser: { keyFields: ["slug"] },
  CurrentUserTaskWasUpdatedPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DailyActionTask: { keyFields: ["id"] },
  DataPartner: { keyFields: ["slug"] },
  DateRangeSpecific: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DecisiveActionNotification: { keyFields: ["id"] },
  DecisiveEventInterface: { keyFields: ["id"] },
  DecisivePlayerPickerTask: { keyFields: ["id"] },
  DecisivePlayerPickerTaskAppearance: { keyFields: ["id"] },
  DecisivePurchaseNotification: { keyFields: ["id"] },
  Deck: { keyFields: ["slug"] },
  DeliverableItemInterface: { keyFields: ["slug"] },
  DeliverableItemOrder: { keyFields: ["id"] },
  DeliverableItemReward: { keyFields: ["id"] },
  DeliverableItemRewardConfig: { keyFields: ["id"] },
  DeliverableItemVariantsStocks: { keyFields: ["id"] },
  DeliverableItemsRewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  DeliverableWithCustomVariantShopItem: { keyFields: ["id"] },
  DeliverableWithNoVariantShopItem: { keyFields: ["id"] },
  DepositPromotionalEvent: { keyFields: ["slug"] },
  DivisionChangeConfiguration: { keyFields: ["id"] },
  DropChallengeTask: { keyFields: ["id"] },
  EligibilityRules: { keyFields: ["id"] },
  EligibleCollectionRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EmailSubscription: { keyFields: ["slug"] },
  EmailSubscriptionPreferences: { keyFields: ["slug"] },
  EngineConfiguration: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EnglishAuctionSource: { keyFields: ["id"] },
  EthBankWithdrawalIntent: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthDeposit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthMigration: { keyFields: ["id"] },
  EthereumAccount: { keyFields: ["id"] },
  EthereumBankConditionalTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthereumBankTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  EthereumTransaction: { keyFields: ["id"] },
  Event: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ExchangeRate: { keyFields: ["id"] },
  ExperienceDeliverableItem: { keyFields: ["slug"] },
  ExperienceReward: { keyFields: ["id"] },
  ExperienceRewardConfig: { keyFields: ["id"] },
  ExternalDepositNotification: { keyFields: ["id"] },
  ExtraSwapShopItem: { keyFields: ["id"] },
  FaceLandmark: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FastWithdrawal: { keyFields: ["id"] },
  FastWithdrawalWithRates: { keyFields: ["id"] },
  FeaturedLeagues: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedSo5LeaderboardContenders: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FeaturedSo5LeaderboardGroups: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Fee: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Fiat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FiatWalletAccount: { keyFields: ["id"] },
  FixturePlayer: { keyFields: ["id"] },
  FootballAverageStatWithValueType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballContestantType: { keyFields: ["id"] },
  FootballConversionCredit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballGoalEvent: { keyFields: ["id"] },
  FootballManagerTask: { keyFields: ["id"] },
  FootballRewardShopItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FootballRoot: { keyFields: ["id"] },
  FootballSanctionCardEvent: { keyFields: ["id"] },
  FootballSo5NoCardRouteRoot: { keyFields: ["id"] },
  FootballTeamGameStats: { keyFields: ["id"] },
  FootballUserSportProfile: { keyFields: ["id"] },
  ForYouRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  FullWithdrawalRequest: { keyFields: ["id"] },
  GalleryCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Game: { keyFields: ["id"] },
  GameDay: { keyFields: ["id"] },
  GameOfBaseball: { keyFields: ["id"] },
  GameOfBasketball: { keyFields: ["id"] },
  GameWeeklyTask: { keyFields: ["id"] },
  GameWeeklyTaskInterface: { keyFields: ["id"] },
  GameWithCardsPreview: { keyFields: ["id"] },
  GameWithPlayerGameScoresPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  GbBankAccount: { keyFields: ["id"] },
  HighScarcity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HighScarcityStatuses: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HighlightedStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  HistoryTransactionInterface: { keyFields: ["id"] },
  IbanBankAccount: { keyFields: ["id"] },
  ImportedSo5Appearance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InGameCurrencyBalance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  InGameCurrencyNotification: { keyFields: ["id"] },
  InGameCurrencyPack: { keyFields: ["id"] },
  InGameCurrencyReward: { keyFields: ["id"] },
  InGameCurrencyRewardConfig: { keyFields: ["id"] },
  InGameCurrencySource: { keyFields: ["id"] },
  IncompleteCardCollection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Injury: { keyFields: ["id"] },
  Inning: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  IntegerBySportType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  JerseyDeliverableItem: { keyFields: ["slug"] },
  JerseyShopItem: { keyFields: ["id"] },
  JwtToken: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KlarnaPayinConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KycDocumentRequirement: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  KycRequestNotification: { keyFields: ["id"] },
  LeaderboardRewardsConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LevelUpShopItem: { keyFields: ["id"] },
  LeveledUpCard: { keyFields: ["id"] },
  ListedOnMarket: { keyFields: ["slug"] },
  Loan: { keyFields: ["id"] },
  LoanNotification: { keyFields: ["id"] },
  LoanableConfigRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LoanableRoster: { keyFields: ["id"] },
  LoanedToken: { keyFields: ["id"] },
  LobbySection: { keyFields: ["slug"] },
  LobbyTile: { keyFields: ["id"] },
  Location: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  LoomAccount: { keyFields: ["id"] },
  ManagerProgressionNotification: { keyFields: ["id"] },
  ManagerTaskInterface: { keyFields: ["id"] },
  ManagerTeam: { keyFields: ["id"] },
  MangopayApplePayAuthorizationRequest: { keyFields: ["id"] },
  MangopayBankAccountOwnerAddress: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayCreditCardAuthorizationRequest: { keyFields: ["id"] },
  MangopayKlarnaAuthorizationRequest: { keyFields: ["id"] },
  MangopayKycDocument: { keyFields: ["id"] },
  MangopayKycRequest: { keyFields: ["id"] },
  MangopayRemotePreAuthorizationStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayRemoteTransactionStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayRoot: { keyFields: ["id"] },
  MangopayUser: { keyFields: ["id"] },
  MangopayWalletTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MangopayWithdrawal: { keyFields: ["id"] },
  MarketPromotionalEvent: { keyFields: ["slug"] },
  MarketRoot: { keyFields: ["id"] },
  MarketingNotification: { keyFields: ["id"] },
  MarketplacePreference: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MarketplacePromotionalEvent: { keyFields: ["id"] },
  MarketplacePromotionalEvents: { keyFields: ["id"] },
  MarketplaceSportPreferences: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MaximumCardsCountOwnedByUser: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Membership: { keyFields: ["id"] },
  MissedAppearance: { keyFields: ["id"] },
  MissedLineup: { keyFields: ["slug"] },
  MissedLineupNotification: { keyFields: ["id"] },
  MonetaryAmount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  MonetaryReward: { keyFields: ["id"] },
  MonetaryRewardConfig: { keyFields: ["id"] },
  Mutation: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NBACard: { keyFields: ["slug"] },
  NBAPlayer: { keyFields: ["slug"] },
  NBAUserSportProfile: { keyFields: ["id"] },
  NationalTeam: { keyFields: ["slug"] },
  Nationality: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NoCardRoute: { keyFields: ["id"] },
  Node: { keyFields: ["id"] },
  NotificationInterface: { keyFields: ["id"] },
  NotificationPreference: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  NotificationSection: { keyFields: ["slug"] },
  NotificationSubsection: { keyFields: ["slug"] },
  Notifications: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OAuthAccessToken: { keyFields: ["id"] },
  OAuthApplication: { keyFields: ["id"] },
  OfferNotification: { keyFields: ["id"] },
  OnboardingLeaderboard: { keyFields: ["id"] },
  OrderedPlayerGameScores: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OrderedSo5Scores: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OtherBankAccount: { keyFields: ["id"] },
  OverperformAverageScoreConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  OwnedSinceRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Owner: { keyFields: ["id"] },
  OwnerInterface: { keyFields: ["id"] },
  OwnerWithRates: { keyFields: ["id"] },
  Pack: { keyFields: ["id"] },
  PackSource: { keyFields: ["id"] },
  PageInfo: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Passkey: { keyFields: ["id"] },
  PasskeyChallenge: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PasswordEncryptedPrivateKey: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Payment: { keyFields: ["id"] },
  PaymentDepositStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PaymentMethod: { keyFields: ["id"] },
  PaymentRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PaypalAuthorizationRequest: { keyFields: ["id"] },
  PendingDeposit: { keyFields: ["id"] },
  PeriodScore: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PickableCard: { keyFields: ["slug"] },
  PickablePlayer: { keyFields: ["slug"] },
  PickableTeam: { keyFields: ["slug"] },
  PictureFrameShopItem: { keyFields: ["id"] },
  Player: { keyFields: ["slug"] },
  PlayerGameScore: { keyFields: ["id"] },
  PlayerGameScoreInterface: { keyFields: ["id"] },
  PlayerGameScoreProjection: { keyFields: ["id"] },
  PlayerGameStats: { keyFields: ["id"] },
  PlayerGameStatsBaseball: { keyFields: ["id"] },
  PlayerGameStatsBasketball: { keyFields: ["id"] },
  PlayerHeightRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PlayerRecommendation: { keyFields: ["id"] },
  PlayerWithSupply: { keyFields: ["slug"] },
  PlayingStatusOdds: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PoolKeyShardsCount: { keyFields: ["slug"] },
  PostalAddress: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PotentialDiscountBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PowerBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PowerPointsBreakdown: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  PreRegistrationData: { keyFields: ["id"] },
  PrimaryOfferSource: { keyFields: ["id"] },
  PrintablePlayerSource: { keyFields: ["id"] },
  PrivateAccount: { keyFields: ["id"] },
  PrivateEmptyAccount: { keyFields: ["id"] },
  PrivateFiatWalletAccount: { keyFields: ["id"] },
  PrivateKeyRecoveryOption: { keyFields: ["id"] },
  PrivateKeyRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbabilisticBundle: { keyFields: ["id"] },
  ProbabilisticBundleConfig: { keyFields: ["id"] },
  ProbabilisticBundleConfigSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbabilisticBundleOpeningDisclaimer: { keyFields: ["slug"] },
  ProbabilisticBundleReward: { keyFields: ["id"] },
  ProbabilisticBundleRewardConfig: { keyFields: ["id"] },
  ProbabilisticBundleSlotArenaTicketItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotCardItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotCardShardItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotConfig: { keyFields: ["id"] },
  ProbabilisticBundleSlotConversionCreditItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotDeliverableItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotInGameCurrencyItem: { keyFields: ["id"] },
  ProbabilisticBundleSlotItemInterface: { keyFields: ["id"] },
  ProbabilisticBundleSlotRewardShopItem: { keyFields: ["id"] },
  ProbabilisticBundleSource: { keyFields: ["id"] },
  ProbabilisticBundlesRewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ProbablePitchersForGameWeek: { keyFields: ["slug"] },
  ProbableRewardConfig: { keyFields: ["id"] },
  ProgressionForRewardConfigThresholds: { keyFields: ["id"] },
  PromotionalEventCompletion: { keyFields: ["id"] },
  PromotionalEventInterface: { keyFields: ["slug"] },
  PublicUserInfoInterface: { keyFields: ["slug"] },
  Query: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RaffleShopItem: { keyFields: ["id"] },
  Range: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RarityCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RarityRewardConfigs: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Rates: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RecommendedConversionCreditTask: { keyFields: ["id"] },
  Referral: { keyFields: ["id"] },
  ReferralChallengeStats: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ReferralConversionCreditConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ReferralLeaderboard: { keyFields: ["id"] },
  ReferralLeaderboardRanking: { keyFields: ["id"] },
  ReferralPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ReferralProgramConfig: { keyFields: ["id"] },
  ReferralReward: { keyFields: ["id"] },
  ReferralRewardNotification: { keyFields: ["id"] },
  ReferralSpecialEvent: { keyFields: ["id"] },
  ReferralSpecialEventChallenge: { keyFields: ["id"] },
  ReferralTile: { keyFields: ["id"] },
  RejectedCraftSource: { keyFields: ["id"] },
  ReminderNotification: { keyFields: ["id"] },
  RevealCost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RevealableCardCampaign: { keyFields: ["slug"] },
  RevealableCardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RevealedCardsSummary: { keyFields: ["id"] },
  RevealedEditionsConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardCard: { keyFields: ["id"] },
  RewardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardConfigThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardDeliverableItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardMultiplierConfiguration: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RewardsOverview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  RoomsConfig: { keyFields: ["slug"] },
  SaleNotification: { keyFields: ["id"] },
  ScoringMatrix: { keyFields: ["id"] },
  ScreenshottableCard: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SealingConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchCardHit: { keyFields: ["slug"] },
  SearchCardHits: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchCardSale: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchFacet: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchFacetValue: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroup: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroupValue: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchGroupedCards: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchPlayers: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SearchProcessingTime: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Season: { keyFields: ["id"] },
  SeasonBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SeasonCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SeasonPicture: { keyFields: ["id"] },
  ShopItem: { keyFields: ["id"] },
  ShopItemInterface: { keyFields: ["id"] },
  ShopItemNotification: { keyFields: ["id"] },
  ShopItemReward: { keyFields: ["id"] },
  ShopItemRewardConfig: { keyFields: ["id"] },
  SignInMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SignInWithOAuthMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SignUpMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SignedCardPrice: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SkinShopItem: { keyFields: ["id"] },
  So5ActiveClubsBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ActiveClubsRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ActiveNationalTeamsRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5AgeRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Appearance: { keyFields: ["id"] },
  So5AppearanceInterface: { keyFields: ["id"] },
  So5AppearancePreview: { keyFields: ["id"] },
  So5AtLeastOfClubs: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5AtLeastOfCompetitions: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5AverageScoresBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5AverageScoresRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5BoostBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Campaign: { keyFields: ["slug"] },
  So5CampaignSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CampaignSectionItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CaptainBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CaptainRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CaptainScarcityRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CardEditionsCountRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CardRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5CardShardsEntryItem: { keyFields: ["id"] },
  So5CollectionBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Competition: { keyFields: ["slug"] },
  So5CompetitionsRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Config: { keyFields: ["id"] },
  So5DeliverableItemReward: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5DifferentNationalitiesBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5EntryItemInterface: { keyFields: ["id"] },
  So5EntryItemRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Fixture: { keyFields: ["slug"] },
  So5FixturePreparing: { keyFields: ["slug"] },
  So5FixturePublicInterface: { keyFields: ["slug"] },
  So5GradeBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Leaderboard: { keyFields: ["slug"] },
  So5LeaderboardContender: { keyFields: ["slug"] },
  So5LeaderboardEntryItemSource: { keyFields: ["id"] },
  So5LeaderboardGroup: { keyFields: ["slug"] },
  So5LeaderboardGroupInterface: { keyFields: ["slug"] },
  So5LeaderboardTask: { keyFields: ["id"] },
  So5LeaderboardTaskInterface: { keyFields: ["id"] },
  So5League: { keyFields: ["slug"] },
  So5LeagueTrack: { keyFields: ["slug"] },
  So5LeagueTrackGroup: { keyFields: ["slug"] },
  So5Lineup: { keyFields: ["id"] },
  So5LineupBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupImport: { keyFields: ["id"] },
  So5LineupImportsBatch: { keyFields: ["id"] },
  So5LineupNotification: { keyFields: ["id"] },
  So5LineupPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupSimulatedResult: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5LineupSimulatedResults: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5MalusAfterTransferBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5MaximumPlayersAverageScoreRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5MinimumPlayersAverageScoreRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NationalityBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NationalityRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NoCardAppearance: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NoCardDraftableAppearance: { keyFields: ["id"] },
  So5NoCardLineup: { keyFields: ["id"] },
  So5NoCardRouteFixturePickConfig: { keyFields: ["id"] },
  So5NoCardRoutePickingSlot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5NotNationalityRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5OnboardingPromotionalEvent: { keyFields: ["id"] },
  So5PlayerBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PlayerLoyaltyRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Podium: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PositionBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PositionStacksBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5PotentialRewardConfigs: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Ranking: { keyFields: ["id"] },
  So5RankingsPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Rarity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RarityVaultRewardBoost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Reward: { keyFields: ["slug"] },
  So5RewardCardConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardConfig: { keyFields: ["id"] },
  So5RewardConfigLock: { keyFields: ["slug"] },
  So5RewardConfigWithEligibility: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardExperience: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RewardSource: { keyFields: ["id"] },
  So5RewardTargetConfig: { keyFields: ["slug"] },
  So5Root: { keyFields: ["id"] },
  So5RuleDescription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RuleDescriptionItem: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5RuleFeedback: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Rules: { keyFields: ["id"] },
  So5SameActiveClubBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SameActiveClubRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ScarcityBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5ScarcityRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Score: { keyFields: ["id"] },
  So5SeasonBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SeasonBonusRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5SpecialEditionCardBonus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5Tournament: { keyFields: ["id"] },
  So5Trophies: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5UserGroup: { keyFields: ["slug"] },
  So5UserGroupMembership: { keyFields: ["id"] },
  So5UserGroupMembershipsPaginated: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  So5UserGroupNotification: { keyFields: ["id"] },
  So5UserGroupTournament: { keyFields: ["id"] },
  SocialPictureDerivative: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaAccount: { keyFields: ["id"] },
  SolanaBankConditionalTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaBankTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaBankWithdrawalAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SolanaTokenTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SorarePrivateKey: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SortingType: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SpecialEditionPromotionalEvent: { keyFields: ["slug"] },
  SpecialWeeklyBanner: { keyFields: ["slug"] },
  SportSeason: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SportStat: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StageGroup: { keyFields: ["id"] },
  StarPackTask: { keyFields: ["id"] },
  StarkexLimitOrderAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkexTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkexV6TokenTransferAuthorizationRequest: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StarkwareAccount: { keyFields: ["id"] },
  StarkwarePrivateAccount: { keyFields: ["id"] },
  StarkwareWithdrawal: { keyFields: ["id"] },
  StartingLineupRevealedActivity: { keyFields: ["id"] },
  StatCustomScoring: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  StatScore: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Stats: { keyFields: ["id"] },
  Story: { keyFields: ["id"] },
  StripeCreditCardAuthorizationRequest: { keyFields: ["id"] },
  Subscription: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  SubstitutionEvent: { keyFields: ["id"] },
  Suspension: { keyFields: ["id"] },
  Task: { keyFields: ["id"] },
  TaskAppearance: { keyFields: ["id"] },
  TaskAppearanceInterface: { keyFields: ["id"] },
  TaskCampaign: { keyFields: ["slug"] },
  TaskCampaignDetailSection: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepage: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepageCampaign: { keyFields: ["slug"] },
  TaskCampaignsHomepageTutorial: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskCampaignsHomepageTutorialSection: { keyFields: ["slug"] },
  TaskConfig: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TaskGroup: { keyFields: ["slug"] },
  TaskInterface: { keyFields: ["id"] },
  TaskNotification: { keyFields: ["id"] },
  TaskSource: { keyFields: ["id"] },
  TasksTrack: { keyFields: ["id"] },
  TeamFormation: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TeamGameStatsInterface: { keyFields: ["id"] },
  TeamInterface: { keyFields: ["slug"] },
  TeamVariantStock: { keyFields: ["id"] },
  TeamsPlayingNextGameWeek: { keyFields: ["slug"] },
  ThreeDimensionalAsset: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThreeDimensionalCardLayout: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdStreakTaskCurrentThresholdStatus: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdStreakTaskThreshold: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ThresholdsDuoConnectionTask: { keyFields: ["id"] },
  ThresholdsStreakTask: { keyFields: ["id"] },
  TicketsDeliverableItem: { keyFields: ["slug"] },
  TitleBodyNotificationMobileRendering: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TitleBodyNotificationRendering: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenAuction: { keyFields: ["id"] },
  TokenBid: { keyFields: ["id"] },
  TokenDeposit: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenMonetaryReward: { keyFields: ["id"] },
  TokenMyBid: { keyFields: ["id"] },
  TokenOffer: { keyFields: ["id"] },
  TokenOfferSide: { keyFields: ["id"] },
  TokenOperationTradeInterface: { keyFields: ["id"] },
  TokenOwner: { keyFields: ["id"] },
  TokenPrice: { keyFields: ["id"] },
  TokenPrimaryOffer: { keyFields: ["id"] },
  TokenRoot: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TokenWithdrawal: { keyFields: ["id"] },
  TopGainers: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TopVolume: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TournamentCalendarStage: { keyFields: ["id"] },
  TournamentEligibility: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TradedPlayer: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  TrophiesSummary: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  UnblockEmailPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  UnknownSource: { keyFields: ["id"] },
  UsBankAccount: { keyFields: ["id"] },
  UsedInSo5Lineups: { keyFields: ["slug"] },
  UsedInTasks: { keyFields: ["slug"] },
  User: { keyFields: ["slug"] },
  UserAccountEntry: { keyFields: ["id"] },
  UserAward: { keyFields: ["slug"] },
  UserAwardNotification: { keyFields: ["id"] },
  UserCardCollection: { keyFields: ["id"] },
  UserCardCollectionSlot: { keyFields: ["slug"] },
  UserCardsCount: { keyFields: ["slug"] },
  UserDevice: { keyFields: ["id"] },
  UserDeviceEvent: { keyFields: ["id"] },
  UserError: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  UserFixtureResults: { keyFields: ["slug"] },
  UserFlag: { keyFields: ["id"] },
  UserGroupCreatedActivity: { keyFields: ["id"] },
  UserGroupInterface: { keyFields: ["slug"] },
  UserGroupMemberJoinedActivity: { keyFields: ["id"] },
  UserGroupMembershipInterface: { keyFields: ["id"] },
  UserGroupMembershipShopItemsUpdate: { keyFields: ["id"] },
  UserGroupRankedActivity: { keyFields: ["id"] },
  UserOwner: { keyFields: ["id"] },
  UserProfile: { keyFields: ["id"] },
  UserProfileBadge: { keyFields: ["slug"] },
  UserRankingInterface: { keyFields: ["id"] },
  UserRelation: { keyFields: ["id"] },
  UserRelationNotification: { keyFields: ["id"] },
  UserSettings: { keyFields: ["id"] },
  UserShopItem: { keyFields: ["id"] },
  UserSource: { keyFields: ["id"] },
  UserSportProfileInterface: { keyFields: ["id"] },
  UserSportStatistic: { keyFields: ["id"] },
  UserWallet: { keyFields: ["id"] },
  UserWithSubscriptionSlug: { keyFields: ["slug"] },
  UsersFixtureResultsPreview: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Validity: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ValueBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  ValueOpenBoundaries: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  VariantStockCount: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  VaultPointsRule: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  Venue: { keyFields: ["id"] },
  VerificationSession: { keyFields: ["id"] },
  Watchlist: { keyFields: ["slug"] },
  WearableDeliverableItem: { keyFields: ["slug"] },
  WheelConfig: { keyFields: ["slug"] },
  WheelCost: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WheelCostPromotionalEvent: { keyFields: ["slug"] },
  WinningLineup: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WithNotifications: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  WithSubscriptionsInterface: { keyFields: ["slug"] },
  Withdrawal: { keyFields: ["id"] },
  WithdrawalWithRates: { keyFields: ["id"] },
  XPCooldownPromotionalEvent: { keyFields: ["slug"] },
  acceptOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  acceptSo5NoCardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  acceptSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  activateWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addAuctionReminderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addDevicePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addRecommendedLineupToCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addSolanaAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addToCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addToWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addTokensToDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  addWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  approveMigratorPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  bidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  blockUserOffersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  buyCardPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  buyDeliverableShopItemPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  buyShopItemPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  cancelBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  cancelEthBankWithdrawalsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  cancelFastWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  cancelMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  cancelOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  cancelWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  celebrateActivityPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  changePasswordPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  checkPhoneNumberVerificationCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimAnyRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimCardsFromPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimConversionCreditPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimDeliverableItemOrderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimFootballManagerTaskPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimOnboardingEnergyGiftPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimPromotionalEventAirdropPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimReferralRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimRewardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimRewardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimStarterPackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  claimTaskPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  completeDropChallengePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  confirmCardPullPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  confirmDeviceWithCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  confirmSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  confirmSo5LineupsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  confirmSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  consumeCardBoosterPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createCardAuthorizationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createCardRegistrationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createConnectedTasksPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createCryptoDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createDepositBankAccountMutationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createDirectOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createEphemeralLinkPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createEthBankWithdrawalIntentPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createEthMigrationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createEthVaultPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createFastWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createFiatPayerPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createFiatWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createIdentityVerificationSessionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createJwtTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createOnboardingSo5LineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createOrUpdateSingleBuyOfferMinPricePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createPasskeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createSingleSaleOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createWireTransferDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createWithdrawalBankAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  createWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deactivateWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  declineSo5LineupImportsBatchPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  declineSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deleteDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deletePasskeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deletePostalAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deleteSo5LineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deleteSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deleteSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  deleteWithdrawalBankAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  depositWithApplePayPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  destroyAccountPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  destroyReferralPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  destroyWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  detachPaymentMethodPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  disable2faPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  disconnectOmniauthProviderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  dropAndAddCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  editDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  enable2faPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  enrollSCAPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  fetchEncryptedPrivateKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  generateAccountingExtractPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  generateOtpBackupCodesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  generateOtpProvisioningUriPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  generatePasskeyChallengeForCreatePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  generatePasskeyChallengeForSignInPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  generateSo5NoCardLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  hideMyFeaturedSo5LeaderboardGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  joinSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  levelUpCardWithXpCurrencyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  levelUpCardsWithXpCurrencyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  linkEthereumAddressPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  loadPreviousLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  loadSuggestedLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  lockProModePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  markCardShardsChestUnlockedThresholdAsSeenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  markItemAsSeenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  markNotificationsAsReadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  markStoriesAsReadPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  migrateEthPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  pickPulledCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareAcceptOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareAcceptTradeWithWalletAndCreditCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareBankWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareBidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareBuyInGameCurrencyPackWithCreditCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareFastWithdrawalPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareIdealDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareMigrateEthPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  preparePaypalDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  prepareTokenDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  probabilisticBundlesOpenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  pullCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  reactActivityPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  refreshCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  rejectCardPullPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  rejectOfferPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  relayCallPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  removeAuctionReminderPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  removeFromCartPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  removeFromWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  removeTokenFromDeckPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  removeUserFromSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  reportTelemetryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  requestSo5NoCardDraftableAppearancePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  requestSo5NoCardLineupEligibleLeaderboardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  resendConfirmationInstructionsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  resendVerificationCodePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  resetPrivateKeyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  resetSo5NoCardDraftedAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  restartTasksTrackPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  restoreWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  revealBlueprintsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  revealPropertyPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  revokeDevicePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  revokeOAuthAccessTokenForApplicationPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  revokeOAuthAccessTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  saveForLaterPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  sealCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  sendWalletRecoveryPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  setDeviceTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  setTokenTradeStatusPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  signOutFromAllDevicesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  skipOnboardingPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  spendCardShardsChestPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  spinWheelPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  stopAutoBidPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  storeApplePurchaseTokenPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  suggestLineupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  unblockFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  unblockUserOffersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  unlockProModePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  unsealCardsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateCardFiltersPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateExternalEthDepositPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateFavoriteTeamPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateHighlightedCardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateManagerTeamPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateOnboardingSo5LeaderboardPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updatePartnerOffersAgreementPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateSectionNotificationPreferencesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateSo5UserGroupPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateSportProfilePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateSubscriptionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateUserEmailPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateUserProfilePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  updateUserSettingsPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  upsertTaskAppearancesPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  upsertWatchlistPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  validateApplePayMerchantSessionPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  validateFiatWalletPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  verifyInGameCurrencyPackMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  verifyMobilePurchasePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  verifyPhoneNumberPayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
  visitCampaignPagePayload: {
    keyFields: false,
    merge: (existing: any, incoming: any, { mergeObjects }: any) => mergeObjects(existing, incoming),
  },
};
